#import "../../../../../../../../../../../common/graphql/EntityDocumentsFields.graphql"
mutation AttachTripDocument($input: AttachTripDocumentInput!) {
  attachTripDocument(input: $input) {
    entityDocuments {
      ...EntityDocumentsFields
    }
  }
}
